import { useMemo } from "react";

import { useQuery } from "../../utility/useQuery";

export const useAdminEventParams = () => {
  const query = useQuery();
  return useMemo(() => {
    const eventIds = Array.from(
      new Set(
        query
          .getAll("event_id")
          .map((id) => id.trim())
          .filter(Boolean)
      )
    );
    return {
      eventIds,
    };
  }, [query]);
};
